import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';

@Entity()
export class SchoolOperative extends AdornisEntity {
  public static override _class = 'SchoolOperative';

  @Field(() => String, {
    default: v => v ?? '',
  })
  public name!: string;

  @Field(() => String, {
    default: v => v ?? '',
  })
  public email!: string;
}
